import { inject, Injectable } from '@angular/core';
import { catchError, type Observable, of } from 'rxjs';
import { toDataResult, ToResult } from '@team23/ts-result';
import {
    FilterConfigService,
    type FilterDataResult,
    FilterDataStatus,
    SelectFilterModel,
} from '@ui/shared/util-filter';
import { SportAtlasService } from '@ui/shared/util-api';
import type { SportMapFilterKey } from '../../types/sport-map-filter';
import { TypeFilterOptions } from '../../definitions/filter-option-keys';

@Injectable({ providedIn: 'root' })
export class TypeSelectFilterConfigService extends FilterConfigService<SportMapFilterKey, SportAtlasService> {

    constructor() {
        super(
            new SelectFilterModel('types', 'Art der Ergebnisse', []),
            inject(SportAtlasService),
        );
    }

    protected _getOptions$(): Observable<FilterDataResult> {
        return of([
            { value: TypeFilterOptions.All, label: 'Alle' },
            { value: TypeFilterOptions.PublicSportFacility, label: 'Öffentliche Sportanlagen' },
            { value: TypeFilterOptions.SportFacility, label: 'Sportstätten' },
            { value: TypeFilterOptions.SportClub, label: 'Vereine' },
        ])
            .pipe(
                toDataResult(),
                catchError(() => of(ToResult.fromErrorKey(FilterDataStatus.Generic))),
            );
    }
}
